import { useLayoutEffect } from 'react';

import { ServiceCountry } from '@upside/browser-rest-client/lib/service-country-storage';
import { ApplicationContext } from '@upside/spa-shared-context';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export const useInitServiceCountryFromQuery = (
  context?: ApplicationContext,
) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    const queryServiceCountry = searchParams.get('authRegion');

    const validRegions = ['gb', 'au', 'us'];

    if (queryServiceCountry) {
      if (validRegions.includes(queryServiceCountry)) {
        context?.authentication.serviceCountryStorage.set(
          queryServiceCountry as ServiceCountry,
        );
      }

      const newParams = new URLSearchParams(searchParams);
      newParams.delete('authRegion');
      const newUrl =
        location.pathname +
        (newParams.toString() ? `?${newParams}` : '') +
        location.hash;

      navigate(newUrl, { replace: true });
    }
  }, [context, searchParams, location.hash, location.pathname, navigate]);
};
